import { isEqual } from 'lodash';
import { applyMiddleware, legacy_createStore as createStore } from 'redux';
import { thunk, ThunkDispatch } from 'redux-thunk';

import appEnv from '../packages/configuration/appEnv';

import devStore from './config/store.dev';
import prodStore from './config/store.prod';
import { rootReducer } from './reducers';
import { ActionTypes, ApiThunks, AppDevStore, AppStore } from './types';

export const store = isEqual(appEnv.env, 'local') ? devStore : prodStore;

export type AppDispatch = ThunkDispatch<AppStore, ApiThunks, ActionTypes>;

export const createTestStore = (appStore: AppStore | AppDevStore) =>
	createStore(rootReducer, appStore as any, applyMiddleware(thunk));
